import { useEffect, useState } from "react";

export default function useDefaultDepartment() {
  const [defaultDepartment, setDefaultDepartment] = useState(
    JSON.parse(localStorage.getItem("defaultDepartment"))
  );

  useEffect(() => {
    function checkDefaultDepartment() {
      const item = JSON.parse(localStorage.getItem("defaultDepartment"));
      setDefaultDepartment((prev) => {
        if (item?.id !== prev?.id || (!item?.id && !prev?.id)) {
          return item;
        }
        return prev;
      });
    }
    window.addEventListener("localStorageUpdated", checkDefaultDepartment);

    checkDefaultDepartment();
    return () => {
      window.removeEventListener("localStorageUpdated", checkDefaultDepartment);
    };
  }, []);

  return defaultDepartment;
}


